module.exports = __webpack_public_path__ + "static/media/heimdall.70231d48.png";